module.exports = __webpack_public_path__ + "assets/img/pikes-trap.08aee826.png";